import { CALL_API } from "../../api";
import * as ActionTypes from "./content.actionTypes";
import schema from "../../api/schema";

const doUploadImage = data => ({
  [CALL_API]: {
    types: [
      ActionTypes.UPLOAD_IMAGE_REQUEST,
      ActionTypes.UPLOAD_IMAGE_SUCCESS,
      ActionTypes.UPLOAD_IMAGE_FAILURE
    ],
    endpoint: "api/general/upload",
    authorization: true,
    requestInit: {
      method: "POST",
      body: data
    }
  }
});

export const uploadImage = formData => (dispatch, getState) => {
  return dispatch(doUploadImage(formData));
};

const readContents = page => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_CONTENTS_REQUEST,
      ActionTypes.READ_CONTENTS_SUCCESS,
      ActionTypes.READ_CONTENTS_FAILURE
    ],
    endpoint: `api/content?page=${page}`,
    schema: schema.contentsSchema,
    authorization: true
  }
});

export const getContents = page => (dispatch, getState) => {
  if (page === undefined) {
    page = 0;
  }
  return dispatch(readContents(page));
};

export const resetFilter = () => (dispatch, getState) => {
  return dispatch({
    type: ActionTypes.RESET_FILTER
  });
};

const filterContents = (tags, page) => ({
  [CALL_API]: {
    types: [
      ActionTypes.FILTER_CONTENTS_REQUEST,
      ActionTypes.FILTER_CONTENTS_SUCCESS,
      ActionTypes.FILTER_CONTENTS_FAILURE
    ],
    endpoint: `api/content/search${tags}&page=${page}`,
    schema: schema.contentsSchema,
    authorization: true
  }
});

export const getFilteredContents = (tags, page) => (dispatch, getState) => {
  let urlTags = tags.map((tag, index) => {
    return index === 0 ? "tags[]=" + tag : "&tags[]=" + tag;
  });
  if (urlTags.length > 0) {
    urlTags = "?" + urlTags;
  }
  if (page === undefined) {
    page = 0;
  }
  return dispatch(filterContents(urlTags, page));
};

const readContent = id => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_CONTENT_REQUEST,
      ActionTypes.READ_CONTENT_SUCCESS,
      ActionTypes.READ_CONTENT_FAILURE
    ],
    endpoint: `api/content/${id}`,
    schema: schema.contentSchema,
    authorization: true
  },
  payload: {
    id
  }
});

export const getContent = id => (dispatch, getState) => {
  const content = getState().entities.content.byId[id];
  if (content) {
    return Promise.resolve();
  }
  return dispatch(readContent(id));
};

const readTags = () => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_TAGS_REQUEST,
      ActionTypes.READ_TAGS_SUCCESS,
      ActionTypes.READ_TAGS_FAILURE
    ],
    endpoint: "api/content/tags",
    schema: schema.contentsSchema,
    authorization: true
  }
});

export const getTags = () => (dispatch, getState) => {
  return dispatch(readTags());
};

const doCreateContent = data => ({
  [CALL_API]: {
    types: [
      ActionTypes.CREATE_CONTENT_REQUEST,
      ActionTypes.CREATE_CONTENT_SUCCESS,
      ActionTypes.CREATE_CONTENT_FAILURE
    ],
    endpoint: "api/content",
    schema: schema.contentSchema,
    authorization: true,
    requestInit: {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(data)
    }
  }
});

export const createContent = data => (dispatch, getState) => {
  return dispatch(doCreateContent(data));
};

const doUpdateContent = data => ({
  [CALL_API]: {
    types: [
      ActionTypes.UPDATE_CONTENT_REQUEST,
      ActionTypes.UPDATE_CONTENT_SUCCESS,
      ActionTypes.UPDATE_CONTENT_FAILURE
    ],
    endpoint: `api/content/${data._id}`,
    schema: schema.contentSchema,
    authorization: true,
    requestInit: {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(data)
    }
  },
  payload: {
    id: data._id
  }
});

export const updateContent = data => (dispatch, getState) => {
  return dispatch(doUpdateContent(data));
};

const doDeleteContent = id => ({
  [CALL_API]: {
    types: [
      ActionTypes.DELETE_CONTENT_REQUEST,
      ActionTypes.DELETE_CONTENT_SUCCESS,
      ActionTypes.DELETE_CONTENT_FAILURE
    ],
    endpoint: `api/content/${id}`,
    schema: schema.contentSchema,
    authorization: true,
    requestInit: {
      method: "DELETE"
    }
  },
  payload: {
    id
  }
});

export const deleteContent = id => (dispatch, getState) => {
  return dispatch(doDeleteContent(id));
};



// WEBPACK FOOTER //
// ./src/modules/content/content.actions.js